exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".text-metric.good {\n  color: var(--color-green-6);\n}\n\n.text-metric.bad {\n  color: var(--color-orange-1);\n}", ""]);

